import React, {Component} from 'react';
import {connect} from 'react-redux';
// import util from 'Utils/commonUtil';

// Components
import {Card, Grid} from '@material-ui/core';
import BasicButton from 'Components/common/BasicButton';
import ProductImage from 'Components/commonOrder/ProductImage';
import Dialog from 'Components/common/Dialog';
import {openNotification} from 'Actions/notification';
import {T} from 'Actions/translate';
import {ExpandLess, ExpandMore} from '@material-ui/icons';

class InventoryCard extends Component {
    state = {
        num: 0,
        convertPackageDialogOpened: false,
        currentInventroyDetails: {},
        numberSteps: 1,
        changeVal: '',
        isSubInventoryExpanded: false,
    };

    componentWillMount() {
        var currentNumberSteps = this.getCurrentSpecificationNumber(
            this.props.inventroyDetails,
        );
        this.setState({
            numberSteps: currentNumberSteps,
            num: currentNumberSteps,
        });
    }

    changeNum = (value) => {
        let currentSpecificationNumber = 1;
        if (
            this.props.inventroyDetails.flag === 'LargeToSmall' ||
            this.props.inventroyDetails.flag === 'SmallToLarge'
        ) {
            currentSpecificationNumber = this.getCurrentSpecificationNumber(
                this.props.inventroyDetails,
            );
        }
        this.setState({
            num: value,
            numberSteps: currentSpecificationNumber,
        });
        if (this.props.changeNum) {
            this.props.changeNum(this.props.inventroyDetails, value);
        }
    };

    getCurrentSpecificationNumber = (inventroyDetails) => {
        let currentSpecificationNumber = 0;
        if (
            inventroyDetails.sourceSkuQuantity >=
            inventroyDetails.targetSkuQuantity
        ) {
            currentSpecificationNumber = inventroyDetails.sourceSkuQuantity;
        } else if (
            inventroyDetails.targetSkuQuantity >
            inventroyDetails.sourceSkuQuantity
        ) {
            currentSpecificationNumber = inventroyDetails.sourceSkuQuantity;
        }
        return currentSpecificationNumber;
    };

    convertPackageHandle = (inventroyDetails, event) => {
        this.setState({
            convertPackageDialogOpened: true,
            currentInventroyDetails: inventroyDetails,
        });
    };

    closeDialog = () => {
        this.setState({
            convertPackageDialogOpened: false,
        });
    };

    getCurrentNumberSteps = () => {
        var currentNumberSteps = this.getCurrentSpecificationNumber(
            this.props.inventroyDetails,
        );
        setTimeout(() => {
            this.setState({
                numberSteps: currentNumberSteps,
                num: currentNumberSteps,
            });
        }, 50);
    };

    showSubInventory = (sku) => {
        const element = document.getElementById('subInventory-' + sku);
        if (element) {
            if (
                element.style.display === 'none' ||
                element.style.display === ''
            ) {
                element.style.display = 'block';
            } else {
                element.style.display = 'none';
            }
        }

        this.setState((prevState) => ({
            isSubInventoryExpanded: !prevState.isSubInventoryExpanded,
        }));
    };

    render() {
        const {inventroyDetails, localData} = this.props;
        const {
            num,
            convertPackageDialogOpened,
            currentInventroyDetails,
            numberSteps,
            isSubInventoryExpanded,
        } = this.state;
        const subInventoryElement = document.getElementById(
            'subInventory-' + inventroyDetails.sku,
        );
        const isShowSubInventory =
            inventroyDetails.inventoryDetailModelList &&
            inventroyDetails.inventoryDetailModelList.length > 0
                ? true
                : false;

        return (
            <Card className="inventroy-card">
                <Grid
                    className="top-content-container"
                    xs={24}
                    container
                    spacing={0}>
                    <Grid className="sku-details-grid" container spacing={0}>
                        <Grid item xs={12} className="details-grid-box">
                            <div className="sc-details-header-left">
                                <span className="details-grid-title">
                                    {T('sku')}：
                                </span>
                                <span className="sku-value">
                                    {inventroyDetails.sku}
                                </span>
                            </div>
                            <Grid item xs={12}>
                                <div className="details-grid-sku">
                                    <span className="product-name">
                                        {T('fone_order_product_name')}
                                    </span>
                                    <span
                                        className="product-name-value"
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                inventroyDetails.productName,
                                        }}></span>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid
                        className="parent-inventory-content-container"
                        item
                        xs={12}>
                        <Grid className="image-grid" item xs={4}>
                            <div className="image-box">
                                <ProductImage
                                    src={inventroyDetails.productPic}
                                    alt={inventroyDetails.productName}
                                />
                            </div>
                        </Grid>
                        <Grid
                            className="inventory-content-container"
                            item
                            xs={8}>
                            <Grid className="left-content-grid" item xs={6}>
                                <Grid
                                    className="inventroy-details-grid"
                                    container
                                    spacing={0}>
                                    <Grid item xs={12}>
                                        <div className="content-grid-grey">
                                            <label>
                                                {T(
                                                    'fone_order_current_actual_colon',
                                                )}
                                            </label>
                                            {inventroyDetails.totalInventory}
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className="content-grid-grey">
                                            <label>
                                                {T(
                                                    'fone_order_available_stock',
                                                )}
                                            </label>
                                            {inventroyDetails.physicalInventory}
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className="content-grid-grey">
                                            <label>
                                                {T(
                                                    'fone_order_current_locking_colon',
                                                )}
                                            </label>
                                            {inventroyDetails.onholdInventory}
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className="content-grid-grey">
                                            <label>
                                                {T(
                                                    'fone_order_hold_delivery_colon',
                                                )}
                                            </label>
                                            {inventroyDetails.onholdQuantity}
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className="content-grid-grey">
                                            <label>
                                                {T(
                                                    'fone_order_tobeshipped_quantity',
                                                )}
                                            </label>
                                            {
                                                inventroyDetails.tobeshippedQuantity
                                            }
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className="content-grid-grey overflow-hidden">
                                            <label>
                                                {T('product_shippingCondition')}
                                                ：
                                            </label>
                                            {inventroyDetails.shippingCondition}
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid className="right-content-grid" item xs={6}>
                                <Grid
                                    className="inventroy-details-grid"
                                    container
                                    spacing={0}>
                                    <Grid item xs={12}>
                                        <div className="content-grid-grey">
                                            <label>
                                                {T(
                                                    'fone_order_max_inventory_colon',
                                                )}
                                            </label>
                                            {inventroyDetails.maxInventory}
                                        </div>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <div className="content-grid-grey">
                                            <label>
                                                {T(
                                                    'fone_order_security_inventory_colon',
                                                )}
                                            </label>
                                            {inventroyDetails.safetyInventory}
                                        </div>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <div className="content-grid-grey">
                                            <label>
                                                {T(
                                                    'fone_order_replenishing_colon',
                                                )}
                                            </label>
                                            {inventroyDetails.replenishingQuantity
                                                ? inventroyDetails.replenishingQuantity
                                                : 0}
                                        </div>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <div className="content-grid-grey">
                                            <label>
                                                {T(
                                                    'fone_order_backup_quantity',
                                                )}
                                            </label>
                                            {inventroyDetails.stockUpQuantity
                                                ? inventroyDetails.stockUpQuantity
                                                : 0}
                                        </div>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <div className="content-grid-grey">
                                            <label>
                                                {T(
                                                    'fone_order_stockout_quantity',
                                                )}
                                            </label>
                                            {inventroyDetails.stockoutQuantity
                                                ? inventroyDetails.stockoutQuantity
                                                : 0}
                                        </div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div className="content-grid-grey overflow-hidden">
                                            <label>
                                                {T('product_storeCondition')}：
                                            </label>
                                            {inventroyDetails.storeCondition}
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    {/* <Grid className='inventory-detail-card-line'></Grid> */}
                    {isShowSubInventory ? (
                        <Grid
                            className="inventory-detail-shrink-area"
                            item
                            xs={12}
                            onClick={() =>
                                this.showSubInventory(inventroyDetails.sku)
                            }>
                            {isSubInventoryExpanded ? (
                                <div className="inventory-detail-expand_less">
                                    {T('shipment_pick_expand_less')}
                                    <ExpandLess />
                                </div>
                            ) : (
                                <div className="inventory-detail-expand_more">
                                    {T('shipment_pick_expand_more')}
                                    <ExpandMore />
                                </div>
                            )}
                        </Grid>
                    ) : null}

                    <Grid
                        className="sub-inventory-details-container"
                        id={'subInventory-' + inventroyDetails.sku}
                        item
                        xs={12}>
                        {isShowSubInventory
                            ? inventroyDetails.inventoryDetailModelList.map(
                                  (subInventoryItem, subInventoryIndex) => {
                                      return (
                                          <Grid
                                              item
                                              xs={12}
                                              className="inventory-details-card-grid"
                                              key={subInventoryIndex}>
                                              <Grid
                                                  className={
                                                      subInventoryItem.isDirectInventory
                                                          ? 'inventory-detail-model-sku'
                                                          : 'inventory-detail-model-sku non-direct-line'
                                                  }>
                                                  {subInventoryItem.sku}
                                              </Grid>
                                              <Grid item xs={12}>
                                                  <div className="inventory-details-card-children-body">
                                                      <Grid xs={6}>
                                                          <div className="inventory-details-card-children-body-li">
                                                              <span className="inventory-details-card-children-body-label">
                                                                  {T(
                                                                      'fone_order_current_actual_colon',
                                                                  )}
                                                              </span>
                                                              <span>
                                                                  {
                                                                      subInventoryItem.totalInventory
                                                                  }
                                                              </span>
                                                          </div>
                                                          <div className="inventory-details-card-children-body-li">
                                                              <span className="inventory-details-card-children-body-label">
                                                                  {T(
                                                                      'fone_order_current_locking_colon',
                                                                  )}
                                                              </span>
                                                              <span>
                                                                  {
                                                                      subInventoryItem.onholdInventory
                                                                  }
                                                              </span>
                                                          </div>
                                                          <div className="inventory-details-card-children-body-li">
                                                              <span className="inventory-details-card-children-body-label">
                                                                  {T(
                                                                      'fone_order_ddsna',
                                                                  )}
                                                              </span>
                                                              <span>
                                                                  {
                                                                      subInventoryItem.ddnsaDate
                                                                  }
                                                              </span>
                                                          </div>
                                                          <div className="inventory-details-card-children-body-li">
                                                              <span className="inventory-details-card-children-body-label">
                                                                  {T(
                                                                      'fone_order_complete_date',
                                                                  )}
                                                              </span>
                                                              <span>
                                                                  {
                                                                      subInventoryItem.lotExpirationDate
                                                                  }
                                                              </span>
                                                          </div>
                                                          <div className="inventory-details-card-children-body-li">
                                                              <span className="inventory-details-card-children-body-label">
                                                                  {T(
                                                                      'sub_product_shippingCondition',
                                                                  )}
                                                              </span>
                                                              <span>
                                                                  {
                                                                      subInventoryItem.shippingCondition
                                                                  }
                                                              </span>
                                                          </div>
                                                      </Grid>
                                                      <Grid xs={6}>
                                                          <div className="inventory-details-card-children-body-li">
                                                              <span className="inventory-details-card-children-body-label">
                                                                  {T(
                                                                      'fone_order_available_stock',
                                                                  )}
                                                              </span>
                                                              <span>
                                                                  {
                                                                      subInventoryItem.physicalInventory
                                                                  }
                                                              </span>
                                                          </div>
                                                          <div className="inventory-details-card-children-body-li">
                                                              <span className="inventory-details-card-children-body-label">
                                                                  {T(
                                                                      'fone_order_current_lot',
                                                                  )}
                                                              </span>
                                                              <span>
                                                                  {
                                                                      subInventoryItem.lot
                                                                  }
                                                              </span>
                                                          </div>
                                                          <div className="inventory-details-card-children-body-li">
                                                              <span className="inventory-details-card-children-body-label">
                                                                  {T(
                                                                      'fone_order_dnsa',
                                                                  )}
                                                              </span>
                                                              <span>
                                                                  {
                                                                      subInventoryItem.dnsaDate
                                                                  }
                                                              </span>
                                                          </div>
                                                          <div className="inventory-details-card-children-body-li">
                                                              <span className="inventory-details-card-children-body-label">
                                                                  {T(
                                                                      'fone_order_locked_status',
                                                                  )}
                                                              </span>
                                                              <span>
                                                                  {
                                                                      subInventoryItem.holdStatus
                                                                  }
                                                              </span>
                                                          </div>
                                                          <div className="inventory-details-card-children-body-li">
                                                              <span className="inventory-details-card-children-body-label">
                                                                  {T(
                                                                      'sub_product_storeCondition',
                                                                  )}
                                                              </span>
                                                              <span>
                                                                  {
                                                                      subInventoryItem.storeCondition
                                                                  }
                                                              </span>
                                                          </div>
                                                      </Grid>
                                                  </div>

                                                  <Grid xs={12}>
                                                      <div className="inventory-details-card-locked-status">
                                                          <span className="locked-status-label">
                                                              {T(
                                                                  'fone_order_locked_reason',
                                                              )}
                                                          </span>
                                                          <span className="locked-status-value">
                                                              {
                                                                  subInventoryItem.holdDescription
                                                              }
                                                          </span>
                                                      </div>
                                                  </Grid>
                                              </Grid>
                                              <Grid className="inventory-detail-card-line"></Grid>
                                          </Grid>
                                      );
                                  },
                              )
                            : null}
                    </Grid>
                </Grid>
                <Dialog
                    options={{bgClickClose: true}}
                    opened={convertPackageDialogOpened}
                    dialogDidClose={this.closeDialog}>
                    <div className="confirm-popup">
                        <Grid
                            className="confirm-title-container"
                            container
                            spacing={0}>
                            <Grid className="confirm-title-grid" item xs={12}>
                                <span>
                                    {T(
                                        'product_management_conversion_specification',
                                    )}
                                </span>
                            </Grid>
                        </Grid>
                        <Grid>
                            <Grid
                                className="comfirm-content-container"
                                container
                                spacing={0}
                                justify={'center'}>
                                <Grid className="confirm-sku-label" item xs={3}>
                                    <span>{T('product_management_sku')}</span>
                                </Grid>
                                <Grid className="confirm-num-grid" item xs={4}>
                                    <span>{currentInventroyDetails.sku}</span>
                                </Grid>
                                <Grid className="confirm-sku-label" item xs={2}>
                                    <span>
                                        {T('product_management_nubmer_colon')}
                                    </span>
                                </Grid>
                                <Grid className="confirm-num-grid" item xs={3}>
                                    <span>
                                        {num}
                                        {T('product_management_nubmer')}
                                    </span>
                                </Grid>
                            </Grid>
                            <Grid className="product_converted-grid">
                                {T('product_management_product_converted')}
                            </Grid>
                            <Grid
                                className="comfirm-content-container"
                                container
                                spacing={0}
                                justify={'center'}>
                                <Grid className="confirm-sku-label" item xs={3}>
                                    <span>{T('product_management_sku')}</span>
                                </Grid>
                                <Grid className="confirm-num-grid" item xs={4}>
                                    <span>
                                        {currentInventroyDetails.targetSku}
                                    </span>
                                </Grid>
                                <Grid className="confirm-sku-label" item xs={2}>
                                    <span>
                                        {T('product_management_nubmer_colon')}
                                    </span>
                                </Grid>
                                <Grid className="confirm-num-grid" item xs={3}>
                                    <span>
                                        {inventroyDetails.sourceSkuQuantity >=
                                        inventroyDetails.targetSkuQuantity
                                            ? num / numberSteps
                                            : num *
                                              inventroyDetails.targetSkuQuantity}
                                        {T('product_management_nubmer')}
                                    </span>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid
                            className="conversion-button-container"
                            container
                            spacing={0}>
                            <Grid className="default-button-grid" item xs={12}>
                                <BasicButton
                                    disabled={false}
                                    className="confirm-conversion-btn">
                                    <span>
                                        {T(
                                            'product_management_conversion_confirm',
                                        )}
                                    </span>
                                </BasicButton>
                                <BasicButton
                                    disabled={false}
                                    className="cancel-conversion-btn"
                                    onClickOfSingleTap={this.closeDialog}>
                                    <span>{T('cancel')}</span>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData, inventoryQuery} = state;

    return {
        productManagementListLoaded: inventoryQuery.productManagementListLoaded,
        localData,
    };
};

const mapDispatchToProps = {
    openNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(InventoryCard);
